import React, { useEffect, useState, Fragment } from 'react';
import { Modal } from 'react-responsive-modal';
import { Header, Container } from '../../../components/StyledComponents';
import { Grid, Button, Typography, TextField, Box, CircularProgress } from '@mui/material';
import styled from 'styled-components';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { CSVLink } from 'react-csv';

const HeaderBox = styled.div`
	border: 2px solid #F4323290;
	margin: 2rem 0;
	padding: 1rem;
	display: flex;
`;
const Picture = styled.div`
	width: 100%;
	max-width: 11.5rem;
	height: 12rem;
	background: #C4C4C4;
`;
const Info = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1rem;
	width: 100%;
`;
const InfoItem = styled.div`
	padding: 0 1rem;
`;
const Item = styled.div`
	margin-bottom: 0.75rem;
	.name {
		font-weight: bold;
	}
`;
const Text = styled.p`
	font-weight: ${props => props.weight};
	font-size: 1.25rem;
`;

const gridStyle = {
	box: {
		marginTop: '0.5rem',
		marginBottom: '2rem',
	},
	userBox: {
		border: '2px solid #F4323290',
		padding: '1rem',
		width: '100%'
	},
	picture: {
		width: '100%',
		maxWidth: '11.5rem',
		height: '12rem',
		background: '#C4C4C4'
	},
	container: {
		marginTop: '0rem',
		marginBottom: '2rem'
	},
	gridItem: {
		display: 'flex',
		gap: '1rem',
	},
	btnArray: {
		display: 'flex',
		gap: '1rem',
		maxWidth: '25rem',
	},
	btn: {
		height: '3.5rem',
		width: '100%'
	},
	trxHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: '1rem'
	},
};

const ViewUser = ({ open, close, data }) => {
	let id = (data.id).toString();
	const [comment, setComment] = React.useState(false);
	const cols = [
		{
			name: 'Transaction ID',
			selector: row => row.transaction_id
		},
		{
			name: 'Customer Name',
			selector: row => row.account_name
		},
		{
			name: 'Amount',
			selector: row => Number(row.amount).toLocaleString()
		},
		{
			name: 'Trx Type',
			selector: row => row["Transaction Type"],
			sortable: true,
		},
		{
			name: 'Status',
			selector: row => <Box sx={{ textTransform: 'capitalize' }}>{row.status}</Box>
		}
	];

	const [loading, setLoading] = useState(false);
	const [report, setReport] = useState(null);
	const [error, setError] = useState(null);
	const token = sessionStorage.getItem('token');
	const getTransactions = async () => {
		setLoading(true);
		const config = {
			method: 'get',
			url: 'list/transactions',
			headers: { 
				'Authorization': 'Bearer ' + JSON.parse(token),
			}
		}

		try {
			const response = await axios(config);
			if(response.status === 200) {
				setLoading(false);
				let data = response.data;
				data = data.sort((a, b) => new Date(a["Transaction date"]) > new Date(b["Transaction date"]) ? -1 : 1);
				data = data.filter(item => id === item.initiator_id);
				setReport(data);
			}
		} catch (error) {
			setLoading(false);
			setError(error);
			console.log(error);
		}
	}

	useEffect(() => {
		getTransactions();
	}, []);
	
	return (
		<Modal classNames={{ modal: 'auditModal' }} open={open} onClose={close} center>
			<Container>
				<Header>User Audit - Summary</Header>
				<HeaderBox>
					<Picture>
						{/* <img src="" alt="user" /> */}
					</Picture>
					<Info>
						<InfoItem>
							<Item>
								<Text className='name'>{data.Name}</Text>
							</Item>
							<Item>
								<Text>User ID: {data.id}</Text>
							</Item>
							<Item>
								<Text>Designation: {data["User Role"]}</Text>
							</Item>
						</InfoItem>
						{/* <InfoItem>
							<Item><Text>Home address:</Text></Item>
							<Item><Text>Business address:</Text></Item>
							<Item><Text>Area code:</Text></Item>
							<Item><Text>State: [state]</Text></Item>
						</InfoItem> */}
					</Info>
				</HeaderBox>
				<Grid container spacing={4} sx={gridStyle.container}>
					<>
						{
							comment === true &&
							<Grid item xs={12} sx={{ marginY: '1rem' }}>
								<Box component="form">
									<TextField label="Add comment" multiline rows={4} fullWidth />
								</Box>
							</Grid>
						}
					</>
					<Grid item xs={12}>
						<Box sx={gridStyle.btnArray}>
							<Button onClick={() => setComment(comment === true ? false : true)} variant="outlined" sx={gridStyle.btn} >
								{
									comment === false ? "New Comment" : "Cancel"
								}
							</Button>
							{
								comment === true && <Button variant="contained" sx={gridStyle.btn}>Add Comment</Button>
							}
						</Box>
					</Grid>
					<Grid xs={12} item>
						<Box sx={gridStyle.trxHeader}>
							<Typography variant="h6">Recent Transactions</Typography>
							<Button type="button" variant="outlined">
								{
									report &&
									<CSVLink data={report} filename="transactions.csv" className='download-link'>
										download
									</CSVLink>
								}
							</Button>
						</Box>
						<Box sx={{ marginY: '1rem' }}>
						<Fragment>
							{
								loading === true && !report ?
								<Box sx={{ height: '20vh', display: 'grid', placeItems: 'center' }}>
									<CircularProgress />
								</Box> :
								(
									error ? <Typography variant="h6" color="error" sx={{ width: '100%', maxWidth: '400px' }}>{error.response.data}: {error.message}</Typography> :
									report !== null &&
									<DataTable
										columns={cols}
										data={report}
										pagination paginationPerPage={5}
									/>
								)
							}
						</Fragment>
						</Box>
					</Grid>
					<Grid item xs={12} sm={6} sx={gridStyle.gridItem}>
						<Button variant="contained" fullWidth sx={gridStyle.btn}>submit</Button>
					</Grid>
					<Grid item xs={12} sm={6} sx={gridStyle.gridItem}>
						<Button variant="outlined" fullWidth sx={gridStyle.btn} onClick={close}>Cancel</Button>
					</Grid>
				</Grid>
			</Container>
		</Modal>
	)
}

export default ViewUser;